import {
  Component, NgModule, OnDestroy, OnInit, EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild
} from '@angular/core';
import { DemoService } from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import { Routes, RouterModule, Router } from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

import { ngf, ngfModule } from 'angular-file';

import { DatePipe } from '@angular/common'; 
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule, NgForm } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import { BehaviorSubject, Observable, Subject, map, Subscription } from 'rxjs';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';

import { SystemFile } from './../../../shared/models/systemFile.model';
import { Job } from './../../../shared/models/job.model';
import { Permission } from './../../../shared/models/permission.model';
import { SystemLog } from './../../../shared/models/sysLog.model';
import { DataUtil } from '@syncfusion/ej2-data';
import { ReactiveFormsModule } from '@angular/forms';

import { platformBrowserDynamic } from "@angular/platform-browser-dynamic"
import { BrowserModule } from '@angular/platform-browser'
import { DndDirective } from './dnd.directives';
import { UploadProgressComponent } from './upload-progress/upload-progress.component';

import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';


@Component({
  selector: 'app-job-file-upload-widget',
  templateUrl: './job-file-upload-widget.component.html',
  styleUrls: ['./job-file-upload-widget.component.css'],
  providers: [DndDirective, UploadProgressComponent ]
})
export class JobFileUploadWidgetComponent implements OnInit, OnChanges {
  
  // setup as observable?
  @Input() item_id?; // impliments on changes.
  @Input() item_data?; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data?= 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id?= '5'; // default to agent just in case
  @Input() item_brand_type_id?;
  @Input() show_buttons?= 'no'; // yes | no
  @Input() widget_title?= 'File Uploads';
  @Input() widget_size?; // side | abstract | full | attempt

  @Input() subject_id?: any;
  @Input() file_number?: any; // subject file number
  @Input() subject_number?: any; // subject file number
  @Input() brand_type_id?: number; // subject file number
  @Input() reference_number?: any; // subject file number
  
  @Input() subject_service_id?: any; // subject file number
  @Input() service_file_array?: any; // subject file number


  @Input() log_type_id?: any; // subject file number


  @Input() job_id: any;
  model: any; // File upload permissions model.
  job: any;
  file_model: SystemFile;


  //  :: file uploader Variables
  // map the result through the model
  create_file: SystemFile;
  //create_files: File[];
  create_sys_log: SystemLog;
  permission_model: Permission;

  // accept = '*'
  accept = '.png, .doc, .docx, .jpg, .jpeg, .txt, .pdf, .csv, .xml, .json, .xls, .xlsx, .zip, .rar ';
  // files: File[] = []
  public files: NgxFileDropEntry[] = [];


  progress: number

  url = this.gfunc.php_apiURL_SSL + '/uploadFiles.php';
  hasBaseDropZoneOver: boolean = false;
  httpEmitter: Subscription;
  httpEvent: HttpEvent<{}>;
  lastFileAt: Date;

  sendableFormData: FormData; // populated via ngfFormData directive

  dragFiles: any;
  validComboDrag: any;
  lastInvalids: any;
  fileDropDisabled: any;
  maxSize: any;
  baseDropValid: any;
  brand_types: any;
  brands: any;
  user_levels: any;
  tableData: any;
  created_file_name: string;
  file_edit_level: number;
  file_created_response: any;
  returned_created_file_id: any;
  system_log_created_response: any;
  allAgentRecipients: any[];
  assignedAgentsList2: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  current_base_route: string;
  brand_types_data: any;

  allUploadedFiles: any[]; // grab all the files uploaded into an array to set service_file_array

  myFormData:FormData //populated by ngfFormData directive
  current_brand_report_id;
  fileBlob: any;
  b64Blob: any;



// New File Uploader
@Output('onAdd') onAdd: EventEmitter<any> = new EventEmitter();
@Input() is_attach_method?;
@Input() attach_file_array_name?: any; // name of the array if automatically attaching file for attempts


// end file Uploader













  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
    vcr: ViewContainerRef, private router: Router,
    public HttpClient: HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService
  ) {

// Set and Access login Session Variables
// this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
this.current_base_route = this.router.url.substr(0, this.router.url.lastIndexOf('/'));
  
if(this.widget_size == ''){
  this.widget_size = 'full';
}

}







  // check for changes. to load data.
  ngOnChanges(changes) {
    if (changes.item_id) {
      // deal with asynchronous Observable result
      this.job_id = changes.item_id.currentValue;

      // this.job = new Job();
      this.permission_model = new Permission();
      this.file_model = new SystemFile();
      this.getJob(this.job_id);
      this.getBrandTypes();
      // this.getBrands();
      // this.getFormUserLevels();
// setup permissions model
//this.permission_model = new Permission();

if (this.subject_id >= 1 || this.widget_size == 'attempt' || this.widget_size == 'attempt_row' ) { // prevents from loading on jobs card page as not needed. // stops javascript errors.

// console.log('current subject id: ' + this.subject_id);

   this.getSubjectAgentBrandsAssigned_comms(this.subject_id); // just in case
}
// for attempts to pass the array name to auto attach file upon upload


this.permission_model = {
job_id: this.job_id,
subject_id: this.subject_id,
created_by: this.gfunc.sessionUserId,
created_level: this.gfunc.sessionUserLevel,
file_brand_id: this.gfunc.sessionBrandId,
brand_type_id: this.gfunc.sessionBrandTypeId,
assigned_to_agents: JSON.stringify(this.allAgentRecipients)
} as Permission;



// attempts -- brand type id and file_brand_id????
// if ( this.widget_size == 'attempt' || this.widget_size == 'attempt_row' ) {
//   this.permission_model = {
//     job_id: this.job_id,
//     subject_id: this.subject_id,
//     created_by: this.gfunc.sessionUserId,
//     created_level: this.gfunc.sessionUserLevel,
//     file_brand_id: this.gfunc.sessionBrandId,
//     brand_type_id: this.brand_type_id,
//     assigned_to_agents: JSON.stringify(this.allAgentRecipients)
//     } as Permission;
//   }



    }


    // if (changes.attach_file_array_name){
    //   this.attach_file_array_name = changes.attach_file_array_name.curretValue;
    //   }
    
    if (changes.subject_id) {
     this.subject_id = changes.subject_id.currentValue;
     this.subject_number = this.subject_number;
    //  this.getSubjectAgentBrandsAssigned_comms(this.subject_id);


  // this.getSubjectAgentBrandsAssigned_comms(this.subject_id); // just in case
 
 
  // this.permission_model = {
  //   job_id: this.job_id,
  //   subject_id: this.subject_id,
  //   created_by: this.gfunc.sessionUserId,
  //   created_level: this.gfunc.sessionUserLevel,
  //   file_brand_id: this.gfunc.sessionBrandId,
  //   brand_type_id: this.gfunc.sessionBrandTypeId,
  //   assigned_to_agents: JSON.stringify(this.allAgentRecipients)
  //   } as Permission;





    }
  }


  ngOnInit() {

    // if (this.subject_id >= 1) { // prevents from loading on jobs card page as not needed. // stops javascript errors.
    //   this.getSubjectAgentBrandsAssigned_comms(this.subject_id); // just in case
    //   }
      


    // if route == establish client permissions to allow upload on step two of a client job - april 29 2023
  if (this.router.url.includes('/client/jobs/create-job-wizard-step-2/')) {
    this.permission_model = {
      job_id: this.job_id,
      subject_id: this.subject_id,
      created_by: this.gfunc.sessionUserId,
      created_level: this.gfunc.sessionUserLevel,
      file_brand_id: this.gfunc.sessionBrandId,
      brand_type_id: 2, // set ast this was not getting set globally for some resonn BUG april 2023 -- this.gfunc.sessionBrandTypeId,
      assigned_to_agents: JSON.stringify(this.allAgentRecipients)
      } as Permission;
      this.setFilePermissions(this.permission_model)  
    console.log('We are on client page step two - create job')
  } else {
    //  return '';
  }





    // this.permission_model = {
    //   job_id: this.job_id,
    //   subject_id: this.subject_id,
    //   created_by: this.gfunc.sessionUserId,
    //   created_level: this.gfunc.sessionUserLevel,
    //   file_brand_id: this.gfunc.sessionBrandId,
      // brand_type_id: this.gfunc.sessionBrandTypeId,
    //   assigned_to_agents: ''
    //   // assigned_to_agents: JSON.stringify(this.allAgentRecipients)
    //   } as Permission;
    
  }







  // Functions
  getJob(job_id) {
    this._demoService.getJobID(job_id).subscribe(
      data => {
        this.job = data;
        let res = data[0];

        /*       // Run the job data queries.
             this.getJobType(res.job_type_id);
             this.getJobPlaintiffType(res.job_plaintiff_type_id);
             this.getJobTypeLocation(res.job_type_location_id);
             this.getJobTypeCourt(res.job_type_court_id);
             this.getJobTypeDocument(res.job_type_document_type_id);
             this.getJobTypeAffidavit(res.job_type_affidavit_type_id);
             this.getReportBrand(res.brand_report_id);
             this.getInvoiceBrand(res.brand_invoice_id); // get company invoice brand */
    this.current_brand_report_id = res.brand_report_id;

      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  // permissions


  setFilePermissions(model) {
    // need to set file submission data to set corret file/access upon upload.

// was missing nov 23
    if(model.brand_type_id == 1){
      model.file_brand_id = 94;
      model.assigned_to_agents = '[]';
    }
    if(model.brand_type_id == 2){
      model.file_brand_id = this.current_brand_report_id; // set in get job function above.
      model.assigned_to_agents = '[]';
    }
    if(model.brand_type_id == 3){
      model.file_brand_id = this.allAgentRecipients[0].recipient_brand_id; // gets the agent ID from the first one in the array
      model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);
    }
    
    
    
    this.permission_model = model;

// Do a full permissions file model system upon upload. -- Only for file Uploads.
// client | Agent | Staff
this.permission_model = model;

  };

  setFilePermissionsOnChange(model) {
    // need to set file submission data to set corret file/access upon upload.

// Do a full permissions file model system upon upload. -- Only for file Uploads.
// client | Agent | Staff


if(model.brand_type_id == 1){
  model.file_brand_id = 94;
  model.assigned_to_agents = '[]';
}
if(model.brand_type_id == 2){
  model.file_brand_id = this.current_brand_report_id; // set in get job function above.
  model.assigned_to_agents = '[]';
}
if(model.brand_type_id == 3){
  model.file_brand_id = this.allAgentRecipients[0].recipient_brand_id; // gets the agent ID from the first one in the array
  model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);
}



this.permission_model = model;

  };


  getBrandTypes() {
    this._demoService.getBrandBrandTypes().subscribe(
      data => { 
        this.brand_types = data; 
      
      },
      err => console.error(err),
      // () => console.log('done loading candidate for update')
    );
  }
  getBrands() {
    this._demoService.getBrands().subscribe(
      data2 => {
        this.brands = data2;
        // console.log(data2);
      },
      err => console.error(err),
      () => console.log('done loading User Brands')
    );
  }
  getFormUserLevels() {
    this._demoService.getFormUserLevels().subscribe(
      data2 => {
        this.user_levels = data2;
        console.log(data2);
      },
      err => console.error(err),
      //  () =>  console.log('done loading User Levels')
    );
  }




  // :: File upload

  // upload files

  cancel() {
    this.progress = 0
    if (this.httpEmitter) {
      console.log('cancelled')
      this.httpEmitter.unsubscribe()
    }
  }

  uploadFiles(): Subscription {
    // apends the value to the form.
    this.sendableFormData.append('job_id', this.job_id);
   // this.sendableFormData.append('subject_id', this.subject_id);
    const req = new HttpRequest<FormData>(
      'POST',
      this.url,
      this.sendableFormData, {
      reportProgress: true, responseType: 'text'
    },
    );

    return this.httpEmitter = this.HttpClient.request(req)
      .subscribe(
        event => {
          this.httpEvent = event;
          if (event instanceof HttpResponse) {
            delete this.httpEmitter;
            console.log('request done', event);
            // clears the form for upload
            this.files.length = 0;
            this.refreshList(); // refresh list.
          }
        },
        error => alert('Error Uploading Files: ' + error.message)
      )
  }

  private refreshList(): void {
    // notice the update here for traces
    this.fileUploader.getJobFiles(this.job_id).subscribe(res => this.displayTableData(res));

  }

  private displayTableData(data: any): void {
    this.tableData = data.json();
  }

  deleteJobFile(filename, job_id) {
    if (confirm('Are you sure you want to delete this file? ')) {
      this._mysqlService.deleteJobFile(filename, job_id).subscribe(
        data => {
          // this.getTraceNotes(this.trace_id);
          this.refreshList();
          return true;
        },
        error => {
          console.error('Error deleting Job File!');
         return console.log(error);
        }
      );
    }
  }


  getDate() {
    return new Date();
  }
  // :: end file upload




  // :: File Upload Database and Insert Log

  // New file and document system Permisions on Job file Uploads
  createJobFileData(model, files) {

    // Loop through array
    for (let entry of this.files) {
      /// console.log(entry); // 1, "string", false
      // this.created_file_name = entry.name;
      this.created_file_name = entry.fileEntry.name;

      this.file_edit_level = 3;

      // agemt security: if agent creating then remove other agents from array first
      if(this.gfunc.sessionUserLevel == 5) {
      this.RemoveElementOthersFromAllAgentRecipients(this.gfunc.sessionBrandId); // adds the logged in agents
      }
      //need to loop through all files and do a seperate insert for each.
      // this.created_file_name = fileupload_data;

      const file_server_location = this.gfunc.file_server_location_JobAssets + '/' + this.job_id;
      // need to make this transportable.
      const file_url = this.gfunc.baseUploadURL_JobAssets + '/' + this.job_id + '/' + this.created_file_name;
      const file_folder = this.gfunc.file_folder_jobAssets + '/' + this.job_id;

      // finds last period .  and removes all before. ie extension of a file.
      const ext = this.created_file_name.substr(this.created_file_name.lastIndexOf('.') + 1);

      const file_name = this.created_file_name.slice(0, -5); // removes the extension
      const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
      // UPGRADE Document Model (Insert the File into the database)
      // File Json
      this.create_file = {
        file_name: file_name,
        file_display_name: file_name,
        file_ext: ext,
        file_server_location: file_server_location,
        file_url: file_url,
        file_folder: file_folder,
        file_make: 'uploaded', // automated / updated / created / uploaded / link_created
        file_notes: 'File created via a client upload',
        file_job_id: this.job_id,
        file_subject_id: this.subject_id,
        file_subject_number: this.subject_number,
        created_by: this.gfunc.sessionUserId,
        created_date: this.gfunc.today,
        created_level: this.gfunc.sessionUserLevel,
        
        // file_brand_id: this.gfunc.sessionBrandId, //?? should this be the subject client report brand id???? upon upload
        file_brand_id: this.permission_model.file_brand_id,  // if an agent or a client file or woner. comes from the form drop downs.

        file_access_level: 9, // ? who can access this file and below (client 9 or agent 5 staff 4 manager 3 admin 2 master 1
        is_active: '1',
        file_password: '',
        file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
        updated_by: null,
        updated_date: null,
        prev_file_id: null,    // if updating
        
        brand_type_id: this.permission_model.brand_type_id,  // if an agent or a client file
        
        subject_template_doc_id: null,
        subject_com_type_id: null,
        random_file_name: random_file_name,
        full_file_name: this.created_file_name,
        name: entry.fileEntry.name,
        size: 0,
        type: '',
        file_number: this.file_number,
        reference_number: this.reference_number,
        
        // arrays of sending to - based on subject_template_doc - setup
        agent_access_array: null, // collect current agent ids
        report_access_array: null, // collect client
        invoice_access_array: null, // collect client
        user_access_array: null, // of selected associated users.
        // Give Access to Users associated with this job, agents, client invoice user, client report user
        assigned_to_agents: JSON.stringify(this.allAgentRecipients),
        is_encrypted: 0
        //  subject_service_id: model.subject_service_id,
        //  Need to fix message sysetm to send to real invoice and primary user for company, and
        //  TO DO :  create a send to company listed contact email, as well as fix above,
        //  This means that a user that is a company invoice user, or a primary user (First user created with the account)
        /* 
              agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
              report_access_array: JSON.stringify(this.brand_data), // collect client
              invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
              user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users. */
      } as SystemFile;  /// Rixes the deserialisation errors!!! as File (model)
      // console.log( (JSON.stringify(this.assignedBrandList)) );



      this.createFile(this.create_file);  /// run this inside the function to get the insert file ID for Note.






    } // end loop entry of uploaded files

  }

  createFile(model) {
    this._demoService.createFile(model).subscribe(
      data => {
        this.file_created_response = data;
        const res = data;
        // need to get the returned ID to send to log create action
        // this.returned_created_file_id = this.file_created_response.last_insert_id;
        this.returned_created_file_id = this.file_created_response.last_insert_id;

        let notice_model = [];
        let inserted_file_id = this.returned_created_file_id;
        console.log('InsideFunction Loop: file_ID: ' + this.returned_created_file_id);

        // Now insert the note
        const brand_type_id = this.permission_model.brand_type_id;
        const log_action = 'uploaded';
        const log_name = 'Client Uploaded a job file: ' + this.job_id + ' - ' + this.created_file_name + '';
        this.create_sys_log = {
          log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
          log_action: log_action, // automated / updated / created / uploaded / link_created / sent
          created_by: this.gfunc.sessionUserId,
          created_date: this.gfunc.today,
          subject_id: this.subject_id,
          job_id: this.job_id,
          job_reference_number: this.job_id,
          file_number: this.file_number,
          reference_number: this.reference_number,
          subject_number: this.subject_number,
          // subject_number: model.file_subject_number,
          log_type_id: 1, // see datatable system_log_types
          created_level: this.gfunc.sessionUserLevel,
          brand_type_id: brand_type_id,
          subject_com_type_id: null,
          subject_template_doc_id: null,
          log_name: log_name + ' - ' + this.created_file_name,
          file_id: inserted_file_id,
          last_insert_id: this.returned_created_file_id,
          file_name: this.created_file_name
        } as SystemLog;

        // Set a delay function in javascript. per second to make sure we have the value.

        // this.createSystemLog(this.create_sys_log);
        notice_model = {
          ...model,
          ...this.create_sys_log,
        };

        if(this.subject_id >= 1){
          // subject file
        this.gfunc.insertLog_UploadSubjectFile(notice_model);
        }
        if(this.subject_id == undefined) {
          // job file
          this.gfunc.insertLog_UploadJobFile(notice_model);
          }

        console.log(this.returned_created_file_id);
        this.toastr.success('File uploaded successfully and permissions have been set.');
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  createSystemLog(model) {
    this._demoService.createSystemLog(model).subscribe(
      data => { this.system_log_created_response = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  // :: end file upload database and Insert Log


// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned_comms(subject_id) {
  this.allAgentRecipients = [];
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { 
       this.assignedAgentsList2 = data;

       let newArr = data;
       let  count_of_items = Object.keys(newArr).length;
         // need to do a loop of subject_billing items (.length)
         for(let i=0;i < count_of_items; i++) {
         let res = newArr[i];
         this.allAgentRecipients.push({
           recipient_name: res.name + '',
           recipient_email_address: res.email,
           recipient_brand_id: res.brand_id,
           recipient_subject_id: res.subject_id,
           recipient_brand_type_id: res.brand_type_id,
           recipient_user_id: null,
           recipient_user_level_id: null,
           recipient_type_name: 'Agent',
         });
         } // end for loop
       this.allAgentRecipients = this.allAgentRecipients; // ?? this may be causing errors.
       // set records to send to subject_notes data table
      //  this.model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }



 RemoveElementFromAllRecipients_comms(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allAgentRecipients.forEach((value, index) => {
    if (value.recipient_name === key) {
      this.allAgentRecipients.splice(index, 1);
    }
  });

// set some permission values when removing the array
  this.permission_model.assigned_to_agents = JSON.stringify(this.allAgentRecipients); // update the form (model)
 if (this.allAgentRecipients.length >= 1){
  this.permission_model.file_brand_id = this.allAgentRecipients[0].recipient_brand_id; // gets the agent ID from the first one in the array
 };
 if (this.allAgentRecipients.length <= 0){
  this.permission_model.file_brand_id = 94; // default back to owner.
 };
    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};




RemoveElementOthersFromAllAgentRecipients(key: number) {
  // test! -- load again an then filter and create the array again.
  // this.getSubjectAgentBrandsAssigned2(this.subject_id); // load first then remove. safest option.

  // delay load slightly so I can refresh the allRecpientList first.
  setTimeout(function() {   
}, 2000);
    console.log("Ready to clean array!")

  let array = this.allAgentRecipients;
  // removes all not matching
    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array
    this.allAgentRecipients.forEach((value, index) => {
    if (value.recipient_brand_id !== key) {
      this.allAgentRecipients.splice(index, 1);
    }
  });
  // console.log('allAgentRecipients after Removal Others: ', JSON.stringify(this.allAgentRecipients));

// ::@https://stackoverflow.com/questions/5310304/remove-json-element
// let json = this.allRecipients
// let id_key = "recipient_brand_id";
// delete json[id_key]; // Removes json.foo from the dictionary.



};














// public files: NgxFileDropEntry[] = [];

public dropped(files: NgxFileDropEntry[]) {
  this.files = files;
 
  for (const droppedFile of files) {

    // Is it a file? 
    if (droppedFile.fileEntry.isFile) {
      const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;

// if (droppedFile instanceof DataTransferItem){
//   console.log('instance');
// }

      fileEntry.file((file: File) => {

        // Here you can access the real file
        console.log(droppedFile.relativePath, file);

        // check droppedFile is instanceof DataTransferItem

  // apends the value to the form.
  const formData = new FormData()
  formData.append('job_id', this.item_id);


  if(!file){
    this.toastr.warning("file not located due to drag and drop email. Please upload you email to the desktop first, then drag to the drop zone.")
  }

  // this.changeFile(file);


if (file){
  formData.append('file[]', file, droppedFile.relativePath)

  // this.sendableFormData.append('subject_id', this.subject_id);
        //  const req = new HttpRequest<FormData>(
        //    'POST',
        //    this.url,
        //    formData, {
        //    reportProgress: true, responseType: 'text'
        //  },
        //  );

      // Headers
      const headers = new HttpHeaders({
        'security-token': 'mytokenMEOW'
      })

   this.http.post(this.url, formData, { headers: headers, responseType: 'text' })
   .subscribe(data => {
     // Sanitized logo returned from backend
     console.log(data);
    
     this.toastr.success('file uploaded');
   })


// now upload
this.createJobFileData([],files);

  } // end if file


        /**
        // You could upload it like this:
        const formData = new FormData()
        formData.append('logo', file, relativePath)

        // Headers
        const headers = new HttpHeaders({
          'security-token': 'mytoken'
        })

        this.http.post('https://mybackend.com/api/upload/sanitize-and-save-logo', formData, { headers: headers, responseType: 'blob' })
        .subscribe(data => {
          // Sanitized logo returned from backend
        })
        **/

      });
    } else {
      // It was a directory (empty directories are added, otherwise only files)
      const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
      console.log('Directory Entry:',droppedFile.relativePath, fileEntry);
    }
  }



}

public fileOver(event){
  console.log(event);
}

public fileLeave(event){
  console.log(event);
}



changeFile(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

uploadFile(event) {
    if (event.target.value) {
        const file = event.target.files[0];
        const type = file.type;
        this.changeFile(file).then((base64: string): any => {
            console.log(base64);
            this.fileBlob = this.b64Blob([base64], type);
            console.log(this.fileBlob)
        });
    } else alert('Nothing')
}





}
